<template>
  <div class="bb-search">
    <input
      class="bb-search__input bb-input bb-input_search"
      type="text"
      placeholder="Search"
      :value="valueSearch"
      @input="inputSearch"
    >
    <i class="icon-search bb-search__icon"></i>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'BBSearch',
  props: {
    valueSearch: {
      type: String,
      default: ''
    },
    customStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    getWithSearch () {
      return debounce(this.onSearch, 350)
    }
  },
  methods: {
    inputSearch ({ target }) {
      const { value } = target
      this.getWithSearch(value)
    },
    onSearch (value) {
      this.$emit('update:valueSearch', value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bb-search {
    position: relative;
    display: flex;
    align-items: center;

    &__input {
      width: 100%;
      height: 42px;
      border-radius: 6px;
    }

    &__icon {
      position: absolute;
      left: 13px;
      font-size: 15px;
      z-index: 2;
      color: $color-silver;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBSearch/BBSearch.vue